<template>
  <DatePicker
    :value="value"
    :modal="true"
    :auto-open="pickerOpen"
    :custom-calendar-icon="true"
    data-picker-place-holder="Select date"
    @onApplyDate="handleApply"
    @onClose="handleClose"
  />
</template>

<script setup>
import { ref } from "vue";
import DatePicker from "@components/DatePicker/DatePicker.vue";
import { toApiDateString } from "@components/TiptapEditor/dateNodeUtils";

const props = defineProps({
  initialValue: {
    type: String,
    required: true,
  },
  onDone: {
    type: Function,
    default: null,
  },
});

const emit = defineEmits(["save"]);

const value = ref(props.initialValue);
const pickerOpen = ref(true);

function finish() {
  if (!pickerOpen.value) {
    return;
  }
  pickerOpen.value = false;
  if (typeof props.onDone === "function") {
    props.onDone();
  }
}

function handleApply(date) {
  const isoDate = toApiDateString(date);
  if (isoDate) {
    emit("save", isoDate);
  }
  finish();
}

function handleClose() {
  finish();
}

defineExpose({ pickerOpen });
</script>
